$(document).ready(function(){

  // product page tabs
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    
    $(this).find('a').click(function(e){
      active.removeClass('active');
      active.parents('.cgt-desc').find('.main-content').addClass('cgt-content');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  
    $(this).find('.specifications').click(function(e){
      $(this).parents('.cgt-desc').find('.main-content').removeClass('cgt-content');
    });
  
  });

  $('.sitewide-product .specifications_tab').hide();

  $('.sitewide-product a.specifications').click(function(){
    $('.sitewide-product .specifications_tab').show();
  });
    
  $('a.description').click(function(){
    $('.sitewide-product .specifications_tab').hide();
  });

  // sitemap page smooth scroll
  $('#az-navigation ul li.active_letter a').on('click', function (e) {
    e.preventDefault();
    alert("click sitemap");
    
    var targetId = $(this).attr('href');
    var target = $(targetId);

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 600);
    }
  });
  
});